import { createSlice, PayloadAction } from "@reduxjs/toolkit";
 
interface AuthState {
  token: string | null;
  role: string | null;
  client_id: string | null;
  isAuthenticated: boolean;
  user_id: string | null; // ✅ Add this
  username?: string | null;
  e_mail?: string | null;
}
 
const initialState: AuthState = {
  token: localStorage.getItem("authToken") || null,
  role: localStorage.getItem("userRole") || null,
  client_id: localStorage.getItem("clientId") || null,
  user_id: localStorage.getItem("userId") || null, // ✅ Load from storage
  isAuthenticated: !!localStorage.getItem("authToken"),
  username: localStorage.getItem("username") || null, 
  e_mail: localStorage.getItem("email") || null,
};
 
const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (
      state,
      action: PayloadAction<{ token: string; role: string; client_id: string, user_id: string; username?: string; e_mail?: string }>,
    ) => {
      state.token = action.payload.token;
      state.role = action.payload.role;
      state.client_id = action.payload.client_id;
      state.user_id = action.payload.user_id;
      state.isAuthenticated = true;
      state.username = action.payload.username || null;
      state.e_mail = action.payload.e_mail || null;
 
      localStorage.setItem("authToken", action.payload.token);
      localStorage.setItem("userRole", action.payload.role);
      localStorage.setItem("clientId", action.payload.client_id);
      localStorage.setItem("userId", action.payload.user_id);
      localStorage.setItem("username", action.payload.username || "");
      localStorage.setItem("email", action.payload.e_mail || "");
    },
    logout: (state) => {
      state.token = null;
      state.role = null;
      state.client_id = null;
      state.user_id = null;
      state.isAuthenticated = false;
      state.username = null;
      state.e_mail = null;
 
      localStorage.removeItem("authToken");
      localStorage.removeItem("userRole");
      localStorage.removeItem("clientId");
      localStorage.removeItem("userId");
      localStorage.removeItem("username");
      localStorage.removeItem("email");
    },
  },
});
 
export const { login, logout } = authSlice.actions;
export default authSlice.reducer;